import React, { useEffect } from "react";

const OrganizationSchema = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "url": window.location.origin,
      "name": "Taste Recovery",
      "logo": `${window.location.origin}/static/media/logo-red.e13c401e.svg`,
      "description": "Taste Recovery is a free, nationwide service for finding safe, peer-reviewed residential rehab treatment centers and more. Search hundreds of listings now!",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1 760 834 5001",
        "contactType": "Customer Service",
        "email": "contact@tasterecovery.com",
      },
      "address": {
        "addressCountry": "US",
        "postalCode": "02116",
        "addressRegion": "Massachusetts",
        "addressLocality": "Boston",
        "streetAddress": "131 Dartmouth Street"
      },
      "sameAs": [
        "https://www.facebook.com/tasterecovery",
        "https://twitter.com/taste_recovery",
        "https://www.instagram.com/tasterecovery"
      ]
    });
    document.head.appendChild(script);

    // Cleanup the script on component unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // No UI is rendered for this component
};

export default OrganizationSchema;
